import { COLOR, mq, UI_LIBRARY_Z_INDEX } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import {
  PC_CAROUSEL_BUTTON_WIDTH,
  SP_CAROUSEL_BUTTON_WIDTH,
  PC_SCROLL_PADDING,
  SP_SCROLL_PADDING,
  PC_ITEM_LEFT_MARGIN,
  SP_ITEM_LEFT_MARGIN,
  PC_CAROUSEL_MARGIN,
  SP_CAROUSEL_MARGIN,
  PC_RANKING_ITEM_LEFT_MARGIN,
  SP_RANKING_ITEM_LEFT_MARGIN,
} from "./const";

const NOT_SCROLL_BAR = `
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;

const BTN_STYLE = `
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: ${UI_LIBRARY_Z_INDEX.CAROUSEL_BUTTON};
  top: 50;
  background: rgb(${COLOR.GRAY50.rgb}, 0.6);
  width: ${PC_CAROUSEL_BUTTON_WIDTH}px;
  height: 100%;

  &:focus {
    opacity: 1;
  }

  @media (any-hover: hover) {
    opacity: 0.6;

    &:hover {
      opacity: 1;
    }
  }

  ${mq.sp} {
    width: ${SP_CAROUSEL_BUTTON_WIDTH}px;
  }
`;

export const BtnNext = styled.button<{
  margin: number;
  showPreviewModal: boolean;
}>`
  ${BTN_STYLE}
  right: 0;
  background: rgba(${COLOR.GRAY50.rgb}, 0.4);
  ${({ showPreviewModal, margin }) =>
    showPreviewModal &&
    `
    top: ${margin}px;
  `}
`;

export const BtnPrev = styled.button<{
  margin: number;
  showPreviewModal: boolean;
}>`
  ${BTN_STYLE}
  left: 0;
  background: rgba(${COLOR.GRAY50.rgb}, 0.4);
  ${({ showPreviewModal, margin }) =>
    showPreviewModal &&
    `
    top: ${margin}px;
  `}
`;

export const DivCarouselWrapper = styled.div<{
  margin: number;
  showPreviewModal: boolean;
}>`
  position: relative;
  width: 100%;
  display: flex;

  // HACK: carousel内部要素にあるpreviewModalがoverflowで隠れないようにする
  ${({ showPreviewModal, margin }) =>
    showPreviewModal &&
    `
      margin-top: -${margin}px;
      margin-bottom: -${margin}px;
      ${BtnNext},${BtnPrev} {
        height: calc(100% - ${margin * 2}px);
      }
    `}

  ${NOT_SCROLL_BAR}

  ${mq.sp} {
    scroll-padding: ${SP_SCROLL_PADDING}px;
  }
`;

export const DivCarouseItem = styled.div<{
  margin: number;
  showPreviewModal: boolean;
}>`
  position: relative;
  width: 100%;
  display: flex;
  overflow-x: auto;
  // MEMO: previewModalの表示とscroll-snap-typeを併用すると、
  // 動作にカクツキがうまれるためpreviewModalを表示する場合ではscroll-snap-typeを適用しない
  @media (any-hover: none) {
    scroll-snap-type: x mandatory;
    scroll-padding: ${PC_SCROLL_PADDING}px;
  }
  overflow-y: hidden;

  ${({ showPreviewModal, margin }) =>
    showPreviewModal &&
    `
    padding-top: ${margin}px;
    padding-bottom: ${margin}px;
  `}

  ${NOT_SCROLL_BAR}

  ${mq.sp} {
    scroll-padding: ${SP_SCROLL_PADDING}px;
  }
`;

export const DivItem = styled.div<{
  displayItemCount: number;
  itemWidthCalc: number;
  isRankingType: boolean;
  isFirstLeftMargin: boolean;
}>`
  flex-shrink: 0;
  scroll-snap-align: start;

  ${({ displayItemCount, itemWidthCalc, isRankingType, isFirstLeftMargin }) => `
    width: calc((100% - ${itemWidthCalc}px) /
    ${displayItemCount});
    margin-left: ${isRankingType ? PC_RANKING_ITEM_LEFT_MARGIN : PC_ITEM_LEFT_MARGIN}px;
    &:first-of-type {
      margin-left: ${isFirstLeftMargin ? PC_CAROUSEL_MARGIN : 0}px;
    }
    &:last-of-type {
      margin-right: ${PC_CAROUSEL_MARGIN}px;
    }

    ${mq.sp} {
      margin-left: ${isRankingType ? SP_RANKING_ITEM_LEFT_MARGIN : SP_ITEM_LEFT_MARGIN}px;
      &:first-of-type {
        margin-left: ${isFirstLeftMargin ? PC_CAROUSEL_MARGIN : 0}px;
      }
      &:last-of-type {
        margin-right: ${SP_CAROUSEL_MARGIN}px;
      }
    }
  `}
`;
